<top-bar-filters
  [reactiveForm]="filtersForm"
  [formLayoutConfig]="filtersLayoutConfig"
  [formControlsConfigMap]="filtersConfigMap"
  [valuesMap]="valuesMap"
  (updateValuesMap)="updateValuesMap($event)"
  (onApply)="applyFilters()"
  (onClear)="clearFilters()"
>
</top-bar-filters>

<div class="historic-row">
  <button mat-stroked-button color="primary" [class.is-active]="historicOn()" type="button" (click)="toggleHistoric()">
    <mat-icon>history</mat-icon>
    {{ historicOn() ? 'Snapshot' : 'Historic' }}
  </button>
</div>

<main class="content">
  @if (error) {
    <div class="state-message state-message--error">{{ error }}</div>
  }

  @if (loading) {
    <div class="kpis">
      <ngx-skeleton-loader count="1" appearance="line" [theme]="skeletonTheme(180, 24)"></ngx-skeleton-loader>
      <ngx-skeleton-loader count="1" appearance="line" [theme]="skeletonTheme(180, 24)"></ngx-skeleton-loader>
      <ngx-skeleton-loader count="1" appearance="line" [theme]="skeletonTheme(180, 24)"></ngx-skeleton-loader>
      <ngx-skeleton-loader count="1" appearance="line" [theme]="skeletonTheme(180, 16)"></ngx-skeleton-loader>
      <ngx-skeleton-loader count="1" appearance="line" [theme]="skeletonTheme(180, 16)"></ngx-skeleton-loader>
    </div>
    <div class="bottom">
      <ngx-skeleton-loader count="1" appearance="line" [theme]="skeletonTheme(320, 16)"></ngx-skeleton-loader>
      <ngx-skeleton-loader count="1" appearance="line" [theme]="skeletonTheme(320, 16)"></ngx-skeleton-loader>
    </div>
  }

  @if (!loading && !error) {
    <!-- Live snapshot view -->
    <div class="live" *ngIf="!historicOn()">
      @if (detailsError) {
        <div class="state-message state-message--error">{{ detailsError }}</div>
      }
      <section class="kpis">
        <app-devices-in-cycle-card
          [summary]="summary!"
          [activeStatus]="activeValue('status')"
          (statusSelect)="toggleFilter('status', $event)"
        />
        <app-deployment-status-card
          [deploymentStatuses]="deploymentStatuses"
          [activeDeploymentStatus]="activeValue('deploymentStatus')"
          (deploymentStatusSelect)="toggleFilter('deploymentStatus', $event)"
        />
        <app-patch-compliance-gauge [compliancePct]="summary!.overallCompliancePct" />
        <app-patches-by-type-bars
          [patchTypes]="patchTypes"
          [activePatchType]="activeValue('patchType')"
          (patchTypeSelect)="toggleFilter('patchType', $event)"
        />
        <app-severity-compliance-bars
          [severities]="severities"
          [activeSeverity]="activeValue('severity')"
          (severitySelect)="toggleFilter('severity', $event)"
        />
      </section>

      <section class="bottom">
        <app-device-compliance-bars
          [devices]="devices"
          [activeDevice]="selectedDevice"
          (deviceSelect)="onDeviceSelect($event)"
        />
        <app-patch-details-table [patches]="patches" [selectedDevice]="selectedDevice" />
      </section>
    </div>

    <!-- Historic trend view -->
    <ng-container *ngIf="historicOn()">
      @if (historyError) {
        <div class="state-message state-message--error">{{ historyError }}</div>
      }
      @if (historyLoading) {
        <div class="trend-grid">
          <ngx-skeleton-loader count="1" appearance="line" [theme]="skeletonTheme(88, 24)"></ngx-skeleton-loader>
          <ngx-skeleton-loader count="1" appearance="line" [theme]="skeletonTheme(88, 24)"></ngx-skeleton-loader>
          <ngx-skeleton-loader count="1" appearance="line" [theme]="skeletonTheme(88, 24)"></ngx-skeleton-loader>
          <ngx-skeleton-loader count="1" appearance="line" [theme]="skeletonTheme(88, 24)"></ngx-skeleton-loader>
        </div>
        <div class="chart-skeleton-container">
          <ngx-skeleton-loader count="1" appearance="line" [theme]="skeletonTheme(270, 8)"></ngx-skeleton-loader>
        </div>
      }
      <app-patch-compliance-trend-view
        *ngIf="historicStats && !historyLoading"
        [trend]="historicTrend"
        [stats]="historicStats"
      />
    </ng-container>
  }
</main>
